import React from 'react'

import { CUSTOM_TEMPLATE, NO_TEMPLATE } from '../../../_templates/Constants'
import { Label } from '../../../../../../packages/kiti/components/presentation/Text'
import {
  usePdfOptionsForm,
  usePdfOptionsFormActions
} from '../../../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import SliderInput from '../../../../../../components/form/SliderInput'

export const QrCodeSize = () => {
  const form = usePdfOptionsForm()
  const { handleChange } = usePdfOptionsFormActions()

  if (![CUSTOM_TEMPLATE, NO_TEMPLATE].includes(form.template)) return false

  return (
    <>
      <Label>Tamanho do QR Code (cm)</Label>
      <SliderInput value={form.qrcodeSize} onChange={handleChange('qrcodeSize')} step="0.1" min="0" max="30" />
    </>
  )
}

export default QrCodeSize
